import { render, staticRenderFns } from "./CloseBead.vue?vue&type=template&id=7673cfc3&scoped=true"
import script from "./CloseBead.vue?vue&type=script&lang=js"
export * from "./CloseBead.vue?vue&type=script&lang=js"
import style0 from "./CloseBead.vue?vue&type=style&index=0&id=7673cfc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7673cfc3",
  null
  
)

export default component.exports